/** API-Client für persistierte Arbeitspaket-Segmente (P2b/B8). */
import apiClient from '../api-client'
import type { CustomSegment, ProductSegmentRule } from '@/components/v2/products/segments/segmentPresets'

const BASE = '/api/v1/product-segments'

export async function listSegments(): Promise<{ success: boolean; segments: CustomSegment[] }> {
  const res = await apiClient.get(BASE)
  return res.data
}

export async function upsertSegment(payload: {
  id?: string
  name: string
  color?: string
  rule: ProductSegmentRule
  pinned?: boolean
}): Promise<{ success: boolean; segment?: CustomSegment }> {
  const res = await apiClient.put(BASE, payload)
  return res.data
}

export async function deleteSegment(id: string): Promise<{ success: boolean }> {
  const res = await apiClient.delete(`${BASE}/${id}`)
  return res.data
}
